import {WEB_TYPES, SCREENS} from '../Redux/NavigationRedux'

import DesktopDefault from './DesktopDefault'
import DesktopHousehold from './DesktopHousehold'
import DesktopLiability from './DesktopLiability'
import MobileDefault from './MobileDefault'
import MobileHousehold from './MobileHousehold'
import MobileLiability from './MobileLiability'

const web = []
web[WEB_TYPES.DEFAULT] = DesktopDefault
web[WEB_TYPES.HOUSEHOLD] = DesktopHousehold
web[WEB_TYPES.LIABILITY] = DesktopLiability

const mobile = []
mobile[WEB_TYPES.DEFAULT] = MobileDefault
mobile[WEB_TYPES.HOUSEHOLD] = MobileHousehold
mobile[WEB_TYPES.LIABILITY] = MobileLiability

export const DESKTOP_NAV = web
export const MOBILE_NAV = mobile

const routeOrder = {}
routeOrder[WEB_TYPES.DEFAULT] = [SCREENS.INIT, SCREENS.PROPERTY_TYPE, SCREENS.PROPERTY, SCREENS.HOUSEHOLD,
	SCREENS.HOUSEHOLD_DETAIL, SCREENS.LIABILITY, SCREENS.LIABILITY_DETAIL, SCREENS.CUSTOMER_FORM, SCREENS.FINAL]
routeOrder[WEB_TYPES.HOUSEHOLD] = [SCREENS.INIT, SCREENS.HOUSEHOLD_DETAIL, SCREENS.PROPERTY, SCREENS.HOUSEHOLD,
	SCREENS.LIABILITY, SCREENS.PROPERTY_TYPE,  SCREENS.LIABILITY_DETAIL, SCREENS.CUSTOMER_FORM, SCREENS.FINAL]
routeOrder[WEB_TYPES.LIABILITY] = [SCREENS.INIT, SCREENS.LIABILITY_DETAIL, SCREENS.PROPERTY, SCREENS.HOUSEHOLD,
	SCREENS.LIABILITY, SCREENS.PROPERTY_TYPE, SCREENS.HOUSEHOLD_DETAIL, SCREENS.CUSTOMER_FORM, SCREENS.FINAL]
export const ROUTE_ORDER = routeOrder
